import React from 'react';
import CartItem from '../components/CartItem';
import {useSelector} from 'react-redux';

const CartScreen = ({history}) => {

    const {cartItems} = useSelector(state => state.cart)
    const userLogin = useSelector(state => state.userLogin);
    const {userInfo} = userLogin;

    const checkOutHandler = () =>{
        console.log('checkout');
        if(!userInfo) {
            history.push('/checkout')
        }else{
            history.push('/checkout/shipping')
        }
    }

    return (
        <div className="pageContainer" id="cart-screen">
            <div className="pageHeader">
                <p>My Cart</p>
            </div>

            {cartItems.length === 0 ? <div>Your cart is empty</div> :
                <div className="pageBody cols">
                    <ul>
                        {cartItems.map((item) => <CartItem key={item.product._id} item={item}/>)}
                    </ul>
                    <div className="checkout">
                        <h3>{cartItems.reduce((acc, item) => acc + parseInt(item.qty), 0)} items added</h3>
                        <h3>Total Price : ₹ {cartItems.reduce((acc, item) => acc + item.product.price * item.qty, 0)}</h3>
                        <button className="btn" onClick={() => checkOutHandler()}>Checkout</button>
                    </div>
                </div>}
            
        </div>
    )
};

export default CartScreen;
